module.exports = __webpack_public_path__ + "static/media/uploadIcon.0632505b.svg";